function toggleCartUpsell() {
  const upsell = document.querySelector(".cart-drawer--recommendations");

  if (upsell.style.display === "none") {
    upsell.style.display = "block";
  }
}

document.addEventListener("click", function (event) {
  if (event.target.matches(".variant-picker-btn button")) {
    var variantButtons = document.querySelectorAll(
      ".variant-picker-btn button"
    );
    variantButtons.forEach((btn) => btn.classList.remove("selected-button"));
    event.target.classList.add("selected-button");
  }

  if (event.target.matches(".atc-button")) {
    var selectedButton = document.querySelector(".v-button.selected-button");
    if (selectedButton) {
      var variantId = selectedButton.dataset.variantId;
      addToCart(variantId);
    } else {
      alert("Vælg en variant");
    }
  }

  var targetElement = event.target;
  while (
    targetElement &&
    !targetElement.matches(".cart-drawer--recommendations")
  ) {
    targetElement = targetElement.parentElement;
  }

  if (targetElement) {
    var secondChild = targetElement.children[1];

    if (secondChild && getComputedStyle(secondChild).display === "none") {
      secondChild.style.display = "block";
    }
  }
});

function getSectionsToRender() {
  return [
    {
      id: "Cart-Drawer",
      section: "cart-drawer",
      selector: ".cart-drawer",
    },
    {
      id: "cart-drawer-toggle",
      section: "cart-bubble",
      selector: ".thb-item-count",
    },
  ];
}

function getSectionInnerHTML(html, selector = ".shopify-section") {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector).innerHTML;
}

function addToCart(variantId) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    }),
  })
    .then((response) => response.json())
    .then((state) => {
      console.log("adding product");
      const parsedState = Object.assign({}, state);

      getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);

        if (parsedState.sections) {
          elementToReplace.innerHTML = getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }
      });
      if (document.getElementById("Cart-Drawer")) {
        document.getElementById("Cart-Drawer").classList.add("active");
        document.body.classList.add("open-cart");
        document.body.classList.add("open-cc");
        if (
          document
            .getElementById("Cart-Drawer")
            .querySelector(".product-recommendations--full")
        ) {
          document
            .getElementById("Cart-Drawer")
            .querySelector(".product-recommendations--full")
            .classList.add("active");
        }
        dispatchCustomEvent("cart-drawer:open");
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      alert("There was an error adding the item to the cart.");
    });
}

document.addEventListener("DOMContentLoaded", function () {
  var mobileElements = document.querySelectorAll(".limited-product-mobile");
  var desktopElements = document.querySelectorAll(".limited-product-desktop");

  mobileElements.forEach(function (mobileElement) {
    mobileElement.addEventListener("click", function () {
      mobileElement.style.display = "none";

      desktopElements.forEach(function (desktopElement) {
        desktopElement.style.display = "block";
      });
    });
  });
});
